import { createBaseApi } from "../baseApi";

export const paymentsApi = createBaseApi("payment", "/payments").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Upload File
    uploadEvidence: builder.mutation({
      query: ({ file, earningsId }) => {
        const payload = new FormData();
        payload.append("file", file);
        if (earningsId) {
          payload.append("earningsId", earningsId);
        }

        return {
          url: "evidence",
          method: "POST",
          body: payload,
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),

    // Delete File
    deleteEvidence: builder.mutation({
      query: ({ id }) => {
        return {
          url: `evidence/${id}`,
          method: "DELETE",
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),
  }),
});

export const { useUploadEvidenceMutation, useDeleteEvidenceMutation } = paymentsApi;
